import ScannerFirmwareModal from './scanner-firmware-modal.connect'

export default ScannerFirmwareModal
